import Envelope from 'modulators/Envelope.js';
import Tone from 'tone';
import ParameterContext from 'effects/ParameterContext.js';

class EnvelopeTrack {
    constructor(sequencerEngine, mixSession, envelopesTrack, number) {
        this.store = sequencerEngine.store;
        this.sequencerEngine = sequencerEngine;
        this.number = number;
        this.envelope = new Envelope(
            sequencerEngine,
            mixSession,
            new ParameterContext().forEnvelopeTrack(this, envelopesTrack),
            number);
    }

    get name() {
        return 'Envelope ' + this.number;
    }

    getJson() {
        return this.envelope.getJson();
    }
}

export default EnvelopeTrack;
